import { ChannelType } from 'common/core/constants/ChannelType'
import { TriggerType } from 'common/flow/constants/TriggerType'
import { ITriggerId } from 'common/flow/flowTriggersInterfaces'
import { MappedLightFlow } from 'shared/api/common/schemas/flow'
import {
  TikTokFollowWelcomeInteraction,
  TikTokFollowWelcomeQuickAction,
  TikTokFollowWelcomeStatus,
} from 'shared/api/requests/tiktok/schemas'

export interface TikTokFollowWelcomeMessage {
  message: string
  interaction: TikTokFollowWelcomeInteraction
  quickReplyText: string | null
  quickActionType: TikTokFollowWelcomeQuickAction | null
}

export interface TikTokFollowWelcomeFlowTrigger {
  id: string
  triggerType: TriggerType.FOLLOW_WELCOME
  triggerId: ITriggerId
  channel: ChannelType
  enabled: boolean
  caption: string
  flowId: string | null
  flow: MappedLightFlow | null
  ctr?: number | null
  runs?: number
  clicked_unq?: number
  ts_created: number
}

export interface TikTokFollowWelcomeState {
  flowId: string | null
  enabled: boolean
  isFetched: boolean
  isToggling: boolean
}

export type TikTokFollowWelcomeTriggerState = Pick<
  TikTokFollowWelcomeState,
  'flowId' | 'enabled' | 'isFetched'
>

export interface TikTokFollowWelcomeMessageState {
  messageEnabled: boolean
  auditStatus: TikTokFollowWelcomeStatus | null
  followWelcome: TikTokFollowWelcomeMessage | null
}

export interface TikTokFollowWelcomeMessageApi {
  /** Null until the first successful load */
  message: TikTokFollowWelcomeMessageState | null
  isLoadFailed: boolean
  /** TikTok turned the feature off for the account, the message is not loaded */
  isUnavailable: boolean
  isToggling: boolean
  load: () => Promise<void>
  toggle: (enabled: boolean) => Promise<void>
  /** Resolves true when the text is saved */
  update: (text: string) => Promise<boolean>
}

export enum TikTokFollowWelcomeSetupStep {
  INTRO = 'intro',
  MESSAGE = 'message',
}

export interface TikTokFollowWelcomeSetupModalState {
  isOpen: boolean
  step: TikTokFollowWelcomeSetupStep
  /** Loaded before opening, the modal has no loading state of its own */
  message: TikTokFollowWelcomeMessageState | null
}

export interface TikTokFollowWelcomeMessageFormValues {
  message: string
}
